export class DischargeInstructions {
    dischargeInstructionId: number;
    dischargeInstructionName: string;
    active: boolean;
    totalItems: number; 
}